
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
  fullWidth?: boolean;
}

export default function Button({
  variant = 'primary',
  size = 'md',
  children,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseClasses = 'font-medium rounded-md transition-colors duration-200 flex items-center justify-center';
  
  const variantClasses = {
    primary: 'text-white hover:opacity-90 active:opacity-80',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 active:bg-gray-300',
    outline: 'border-2 text-white hover:bg-white/10 active:bg-white/20'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm min-h-[40px]',
    md: 'px-6 py-3 text-base min-h-[48px]',
    lg: 'px-8 py-4 text-lg min-h-[56px]'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  const primaryStyle = variant === 'primary' ? { backgroundColor: '#7966FF' } : {};
  const outlineStyle = variant === 'outline' ? { borderColor: '#7966FF', color: '#7966FF' } : {};
  
  return (
    <button
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`}
      style={{ ...primaryStyle, ...outlineStyle }}
      {...props}
    >
      {children}
    </button>
  );
}
